// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
import React from "react";
import { API, graphqlOperation } from "aws-amplify";
import get from "lodash/get";
import LocalStorage, { LocalStorageKey } from "../local-storage/local-storage";
import { Program, CreateProgramInput, DeleteProgramInput } from "../API";
import {
  ProgramContext,
  CreateProgramCartIn,
  DeleteProgramCartIn,
  UpdateProgramCartIn,
} from "../context/program";
import { listPrograms } from "../graphql/queries";

const useCartIn = (programId: string) => {
  const { ProgramDispatch } = React.useContext(ProgramContext);

  const updateCartInUserName = async () => {
    const response = await API.graphql(
      graphqlOperation(listPrograms, {
        id: programId,
        dataType: {
          beginsWith: "cartIn#",
        },
        filter: {
          userId: {
            eq: LocalStorage.get(LocalStorageKey.userId),
          },
        },
      })
    );

    const cartInList = get(response, "data.listPrograms.items", []);

    cartInList.forEach((cartIn: Program) => {
      const { id, dataType, cartInDatetime, productCode, customerId } = cartIn;
      ProgramDispatch(
        UpdateProgramCartIn({
          id,
          dataType,
          cartInDatetime,
          productCode,
          customerId,
          userId: LocalStorage.get(LocalStorageKey.userName),
        })
      );
    });
  };

  const addCartIn = (program: CreateProgramInput) => {
    ProgramDispatch(CreateProgramCartIn(program));
  };

  const deleteCartIn = (program: DeleteProgramInput) => {
    ProgramDispatch(DeleteProgramCartIn(program));
  };

  return {
    updateCartInUserName,
    addCartIn,
    deleteCartIn,
  };
};

export default useCartIn;
